/***
 * Backend url to services.
 */

interface IBackends {
    backend: string;
    frontend: string;
    authBackend: string;
    communication: string;
    globalSetups: string;
    exceptionLog: string;
    document: string;
    issueReport: string;
    devops: string;
    sibaGEN: string;
}
const backends: IBackends = {
    backend: "https://digitals.starassurance.com/",// /sibasalvage/
    frontend: "/sibasalvage/",// /sibasalvage/
    authBackend: "https://sibapps.com/authcore/",
    communication: "/communication/",
    globalSetups: "/",
    exceptionLog: "/logs/",
    document: "/document/management/",
    issueReport: "/",
    devops: "https://dev.azure.com/",
    sibaGEN: ""
};
export default backends;
